import React from "react";
import ReportedErrorBoundary from "../common/ui/ReportedErrorBoundary";

export default function ErrorBoundary({ children }) {
  return (
    <ReportedErrorBoundary
      errorContent={
        <p style={{ paddingLeft: 8 }}>
          Something went wrong. Please try again later.
        </p>
      }
    >
      {children}
    </ReportedErrorBoundary>
  );
}
